import moment from 'moment';
/**
 * All-day events are calendar dates, not instants. The API sends UTC midnights
 * that encode a date (e.g. 2025-06-01T00:00:00Z means "June 1"), not "midnight
 * UTC as a point in time". Extract that date string for use in the event timezone.
 */
export function allDayCalendarDateFromApi(dateTime) {
    return moment.utc(dateTime).format('YYYY-MM-DD');
}
/** Calendar date (YYYY-MM-DD) for a moment in the event timezone. */
export function calendarDateInTimezone(m, timezone) {
    return m.clone().tz(timezone).format('YYYY-MM-DD');
}
/** Start of a calendar day in the event timezone (no UTC→local instant shift). */
export function allDayMomentAtStartOfCalendarDate(calendarDate, timezone) {
    return moment.tz(calendarDate, 'YYYY-MM-DD', timezone).startOf('day');
}
/**
 * Inclusive start + exclusive end for a single selected calendar day.
 * endTime is midnight at the start of the day after the selected date.
 */
export function getAllDayTimeRange(_a) {
    var selectedDate = _a.selectedDate, timezone = _a.timezone;
    var startCalendarDate = calendarDateInTimezone(selectedDate, timezone);
    var startTime = allDayMomentAtStartOfCalendarDate(startCalendarDate, timezone);
    var exclusiveEndCalendarDate = moment
        .tz(startCalendarDate, 'YYYY-MM-DD', timezone)
        .add(1, 'day')
        .format('YYYY-MM-DD');
    var endTime = allDayMomentAtStartOfCalendarDate(exclusiveEndCalendarDate, timezone);
    return { startTime: startTime, endTime: endTime };
}
/** Exclusive end midnight → inclusive end date for range pickers. */
export function allDayInclusiveEndFromExclusiveEnd(exclusiveEnd, timezone) {
    var inclusiveCalendarDate = moment
        .tz(calendarDateInTimezone(exclusiveEnd, timezone), 'YYYY-MM-DD', timezone)
        .subtract(1, 'day')
        .format('YYYY-MM-DD');
    return allDayMomentAtStartOfCalendarDate(inclusiveCalendarDate, timezone);
}
/** Inclusive end date from picker → exclusive end midnight for storage/API. */
export function allDayExclusiveEndFromInclusiveEnd(inclusiveEnd, timezone) {
    var exclusiveCalendarDate = moment
        .tz(calendarDateInTimezone(inclusiveEnd, timezone), 'YYYY-MM-DD', timezone)
        .add(1, 'day')
        .format('YYYY-MM-DD');
    return allDayMomentAtStartOfCalendarDate(exclusiveCalendarDate, timezone);
}
/** True when endTime is local midnight (exclusive all-day boundary). */
export function isAllDayExclusiveEndBoundary(endTime, timezone) {
    var calendarDate = calendarDateInTimezone(endTime, timezone);
    return endTime
        .clone()
        .tz(timezone)
        .isSame(allDayMomentAtStartOfCalendarDate(calendarDate, timezone));
}
